import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'

export function DocumentTitle({ children: subtitle }) {
  const titles = ['Mandiant Advantage']

  if (subtitle) {
    titles.unshift(subtitle)
  }

  return (
    <Helmet>
      <title>{titles.join(' - ')}</title>
    </Helmet>
  )
}

DocumentTitle.propTypes = {
  children: PropTypes.string,
}
